import { RfidSchema } from "mock/schemas"

type RfidSchemaArray = [string, string, string, boolean, boolean, string, string]

const driversArray: RfidSchemaArray[] = [
    ["1", "4643464D84F76A874Q", "RFID card 1", true, false, "1", "1"],
    ["2", "78F6SA6487D684G687", "RFID card 2", true, false, "2", "1"],
    ["3", "A754A25SD63578A4VH", "RFID card 3", true, false, "2", "1"],
    ["4", "A64JH428B7CVX83A1L", "RFID card 4", false, false, "2", "1"],
    ["5", "94TY468GU1L54463JP", "RFID card 5", true, false, "5", "1"],
    ["6", "M6453Y5GB866HG6435", "RFID card 6", true, false, "6", "1"],
    ["7", "A64JH428B7CVX83A1L", "RFID card 7", true, false, "1", "1"],
    ["8", "46486A75PDC264CXW7", "RFID card 8", false, true, "8", "1"],
    ["9", "K43596P787ZHV464L9", "RFID card 9", true, false, "9", "1"],
    ["10", "9QS839KBJR47F98M8Z", "RFID card 10", true, false, "10", "1"],
    ["11", "KGH864P96ZE487VDG9", "RFID card 11", true, false, "11", "1"],
    ["12", "TY92HVB758XQ64AUI1", "RFID card 12", false, true, "12", "1"],
    ["13", "77864TFK674GFA74S8", "RFID card 13", true, false, "13", "1"],
    ["14", "TY92HVB758XQ64AUI1", "RFID card 14", false, false, "14", "1"],
    ["15", "99JSK88314SUH78642", "RFID card 15", true, false, "15", "2"],
    ["16", "TY92HVB758XQ64AUI1", "RFID card 16", false, false, "16", "2"],
    ["17", "HY4878A9SDE8A4D851", "RFID card 17", true, false, "17", "2"],
    ["18", "HGC778HHD4562D99Z4", "RFID card 18", false, false, "18", "2"],
    ["19", "P94KJ4521KJDZ87I94", "RFID card 19", true, false, "19", "2"],
    ["20", "JF684F8G9A4D54499D", "RFID card 20", true, false, "20", "2"],
    ["21", "K43596P787ZHV464L9", "RFID card 21", true, false, "20", "2"],
    ["22", "9QS839KBJR47F98M3A", "RFID card 22", false, true, "20", "2"],
    ["23", "K43596P787ZHV464L9", "RFID card 23", true, false, "23", "2"],
    ["24", "9QS839KBJR47F98M3Q", "RFID card 24", true, false, "24", "2"],
    ["26", "9QS839KBJR47F98M3W", "RFID card 26", false, false, "16", "2"],
    ["27", "K43596P787ZHV464L9", "RFID card 27", false, true, "17", "2"],
    ["28", "9QS839KBJR47F98M3E", "RFID card 28", true, false, "18", "2"],
    ["29", "K43596P787ZHV464L9", "RFID card 29", true, false, "19", "2"],
    ["30", "9QS839KBJR47F98M3R", "RFID card 30", false, false, "10", "1"],
    ["31", "K43596P787ZHV464L9", "RFID card 31", true, false, "11", "1"],
    ["32", "9QS839KBJR47F98M3D", "RFID card 32", false, false, "12", "1"],
    ["33", "K43596P787ZHV464L9", "RFID card 33", false, true, "13", "1"],
    ["34", "9QS839KBJR47F98M3S", "RFID card 34", true, false, "14", "1"],
    ["35", "K43596P787ZHV464L9", "RFID card 35", true, false, "15", "2"],
    ["36", "9QS839KBJR47F98M32", "RFID card 36", true, false, "16", "2"],
    ["37", "K43596P787ZHV464L9", "RFID card 37", true, false, "17", "2"],
    ["38", "9QS839KBJR47F98M31", "RFID card 38", false, false, "18", "2"],
    ["39", "K43596P787ZHV464L9", "RFID card 39", false, false, "19", "2"],
    ["40", "9QS839KBJR47F98M34", "RFID card 40", true, false, "10", "1"],
    ["41", "K43596P787ZHV464L9", "RFID card 41", false, false, "11", "1"],
    ["42", "9QS839KBJR47F98M3T", "RFID card 42", true, false, "12", "1"],
    ["43", "K43596P787ZHV464L9", "RFID card 43", true, false, "13", "1"],
    ["44", "9QS839KBJR47F98M1Z", "RFID card 44", false, true, "14", "1"],
    ["45", "K43596P787ZHV464L9", "RFID card 45", true, false, "15", "2"],
    ["46", "9QS839KBJR47F98M6Z", "RFID card 46", true, false, "16", "2"],
    ["47", "K43596P787ZHV464L9", "RFID card 47", false, false, "17", "2"],
    ["48", "9QS839KBJR47F98M7Z", "RFID card 48", true, false, "18", "2"],
    ["49", "K3596P787ZHV464LFT", "RFID card 49", false, true, "19", "2"],
    ["50", "9QS839KBJR47F98M9Z", "RFID card 50", false, true, "10", "1"],
]

const createRfidObject = (arr: RfidSchemaArray): RfidSchema => {
    return {
        id: arr[0],
        number: arr[1],
        description: arr[2],
        active: arr[3],
        toBeActivated: arr[4],
        driver_id: arr[5],
        entity_id: arr[6],
    }
}

export const rfidsMockDatas: RfidSchema[] = driversArray.map((arr) =>
    createRfidObject(arr)
)
